<template>
  <div id="app">
    <router-view />
    <AgentFab v-if="!agentOpen" />
    <AgentPanel v-else />
  </div>
</template>

<script setup>
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import AgentFab from './components/agent/AgentFab.vue'
import AgentPanel from './components/agent/AgentPanel.vue'
import { useAgentStore } from './stores/agent'

const agent = useAgentStore()
const store = useStore()
const agentOpen = computed(() => agent.open.value)

watch(
  () => store.state.token,
  (token) => {
    if (!token) {
      agent.clearForAuth()
    }
  },
)
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background-color: #f9fafb;
}

#app {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f9fafb;
}

/* 全局自定义滚动条样式 - 特别细且无箭头 */
::-webkit-scrollbar {
  width: 4px;  /* 滚动条宽度设置为很细的4px */
}

::-webkit-scrollbar-track {
  background: transparent;  /* 滚动条轨道透明 */
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.4);  /* 滚动条滑块颜色 */
  border-radius: 2px;  /* 圆角 */
  transition: background-color 0.2s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.6);  /* 悬停时颜色加深 */
}

/* 去掉上下箭头按钮 */
::-webkit-scrollbar-button {
  display: none;  /* 隐藏箭头按钮 */
}

/* 去掉滚动条的角落 */
::-webkit-scrollbar-corner {
  background: transparent;
}
</style> 